import { render, staticRenderFns } from "./TopOutside.vue?vue&type=template&id=238e3355&scoped=true"
import script from "./TopOutside.vue?vue&type=script&lang=js"
export * from "./TopOutside.vue?vue&type=script&lang=js"
import style0 from "./TopOutside.vue?vue&type=style&index=0&id=238e3355&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e3355",
  null
  
)

export default component.exports